import cryptoImg from "../assets/projects/cryptoverse.PNG";
import metaImg from "../assets/projects/metaverse.PNG";
import portfolio from "../assets/projects/portfolio.PNG";

export const projectData = [
  {
    name: "Metaversus",
    bgImg: metaImg,
    liveLink: "https://metaversusbyarjun.netlify.app/",
    sourceCode: "https://github.com/arjun4619/metaversus",
  },
  {
    name: "Cryptoverse",
    bgImg: cryptoImg,
    liveLink: "https://cryptoversebyarjun.netlify.app/",
    sourceCode: "https://github.com/arjun4619/cryptoverse",
  },
  {
    name: "Portfolio",
    bgImg: portfolio,
    liveLink: "https://arjunshankar.netlify.app/",
    sourceCode: "https://github.com/arjun4619/arjun-portfolio",
  },
];
